"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderError = exports.RenderReady = exports.RenderPending = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireDefault(require("react"));

var _reactStaticContainer = _interopRequireDefault(require("react-static-container"));

var _palette = require("@artsy/palette");

var _ = require("./..");

var _ErrorPage = require("../../Components/ErrorPage");

var _ElementsRenderer = _interopRequireDefault(require("found/lib/ElementsRenderer"));

var _sharify = require("sharify");

var _logger = _interopRequireDefault(require("../../Utils/logger"));

var _NetworkTimeout = require("./NetworkTimeout");

var _PageLoader = require("./PageLoader");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var logger = (0, _logger.default)("Artsy/Router/Utils/RenderStatus");

var RenderPending = function RenderPending() {
  var _useSystemContext = (0, _.useSystemContext)(),
      isFetching = _useSystemContext.isFetching,
      setFetching = _useSystemContext.setFetching,
      EXPERIMENTAL_APP_SHELL = _useSystemContext.EXPERIMENTAL_APP_SHELL;
  /**
   * First, set fetching to ensure that components that are listening for this
   * value have a chance to respond to the fetching state. This is necessary
   * because the `<Renderer>` component below will freeze all updates for the
   * duration of the fetch.
   */


  if (!isFetching) {
    setFetching(true);
  }

  if (isFetching) {
    if (EXPERIMENTAL_APP_SHELL) {
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Renderer, null, null), _react.default.createElement(_PageLoader.PageLoader, {
        className: "reactionPageLoader" // positional styling comes from Force body.styl
        ,
        showBackground: false,
        step: 10 // speed of progress bar, randomized between 1/x to simulate variable progress
        ,
        style: {
          position: "fixed",
          left: 0,
          top: -6,
          zIndex: 1000
        }
      }), _react.default.createElement(_NetworkTimeout.NetworkTimeout, null));
    } else {
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Renderer, null, null), _react.default.createElement(_PageLoader.PageLoader, {
        className: "reactionPageLoader" // positional styling comes from Force body.styl
        ,
        showBackground: false,
        style: {
          position: "fixed",
          left: 0,
          top: -6,
          zIndex: 1000
        }
      }));
    }
  }
};

exports.RenderPending = RenderPending;

var RenderReady = function RenderReady(props) {
  var _useSystemContext2 = (0, _.useSystemContext)(),
      isFetching = _useSystemContext2.isFetching,
      setFetching = _useSystemContext2.setFetching;

  if (isFetching) {
    setFetching(false);
  }

  if (!isFetching) {
    return _react.default.createElement(Renderer, {
      shouldUpdate: true
    }, _react.default.createElement(_ElementsRenderer.default, {
      elements: props.elements
    }));
  }
};

exports.RenderReady = RenderReady;

var RenderError = function RenderError(props) {
  logger.error(props.error.data);

  var _useSystemContext3 = (0, _.useSystemContext)(),
      isFetching = _useSystemContext3.isFetching,
      setFetching = _useSystemContext3.setFetching;

  if (isFetching) {
    setFetching(false);
  }

  var message = (process.env.NODE_ENV || _sharify.data.NODE_ENV) === "development" ? String(props.error.data) : "Internal error"; // TODO: Make error code more granular. See:
  // https://artsyproduct.atlassian.net/browse/PLATFORM-1343
  // https://github.com/artsy/reaction/pull/1855

  return _react.default.createElement(_ErrorPage.ErrorPage, {
    code: props.error.status || 500,
    message: message
  });
};
/**
 * Define a container component so that we don't run into reconciliation issues
 * due to an element existing in RenderPending that doesn't exist in RenderReady,
 * between the top most container and StaticContainer.
 *
 */


exports.RenderError = RenderError;

var Renderer = function Renderer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(_palette.Box, null, _react.default.createElement(_reactStaticContainer.default, props, children));
};
//# sourceMappingURL=RenderStatus.js.map